module.exports = __webpack_public_path__ + "static/media/checklist.06ad2f9e.svg";